module.exports = __webpack_public_path__ + "img/logo.1792f1bf.png";